<script>
  import { slide } from 'svelte/transition'
  export let visible = false
</script>

{#if visible}
  <div in:slide>
    <slot/>
  </div>
{/if}

<style>
  div {
    color: var(--c-danger);
    margin-bottom: 2rem;
  }
</style>